
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
	videoLink = "videoLink",
}

interface OwnProps extends WidgetProps {
	fields: {
		[fields.videoLink]: string;
	};
}

type Props = OwnProps & WidgetProps;

export interface YtWidgetStyles {
	infoWrapper?: InjectableCss;
	infoSec?: InjectableCss;
}

export const ytWidgetStyles: YtWidgetStyles = {
	infoWrapper: {
		css: css`
			display: flex;
			font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							flex-direction: column;
							`,
						css`
							flex-direction: column;
							`,
						null,
					],
					"max",
				)}
			.info-sec{
				font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
				&:first-child{
					margin-right: 2%;
					${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
									margin: 20px 0 20px 0;
								`,
						css`
									margin: 20px 0 20px 0;
								`,
						null,
					],
					"max",
				)}
				}
			}
		`
	},
	infoSec: {
		css: css`
			width: 49%;
			iframe{
			}
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							width: 100%;
					`,
						css`
							width: 100%;
					`,
						null,
					],
					"max",
				)}
			iframe{
				${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							aspect-ratio: 16 / 9;
							width: 100%;
							height: auto;
					`,
						css`
							aspect-ratio: 16 / 9;
							width: 100%;
							height: auto;
					`,
						null,
					],
					"max",
				)}
			}
		`
	},
};

const styles = ytWidgetStyles;


const ytWidget: React.FC<Props> = ({ id, fields }: Props) => {
	return (
		<>
			<StyledWrapper {...styles.infoWrapper}>
				<StyledWrapper className="info-sec" {...styles.infoSec} >
					<Zone contentId={id} zoneName={"InfoSection"} />
				</StyledWrapper>
				<StyledWrapper className="info-sec"  {...styles.infoSec}>
					<iframe width="560" height="315" src={fields.videoLink} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
					<StyledWrapper>
						<Zone contentId={id} zoneName="Section01"></Zone>
					</StyledWrapper>
				</StyledWrapper>
			</StyledWrapper>
		</>

	);
};

const basicTab = {
	displayName: "Basic",
	sortOrder: 0,
};


const widgetModule: WidgetModule = {
	component: ytWidget,
	definition: {
		group: "Basic",
		fieldDefinitions: [
			{
				name: fields.videoLink,
				displayName: "Youtube Video Embed Link",
				editorTemplate: "TextField",
				defaultValue: "",
				fieldType: "General",
				tab: basicTab,
			},
		],

	}

};

export default widgetModule;
